import { RegisteredComponent } from "@builder.io/sdk-react";
import { DLD_FIELD, DLT_FIELD } from "@/libs/builder/commonFields";

export const stickyNavigationBlockConfig: Omit<
  RegisteredComponent,
  "component"
> = {
  name: "Sticky Navigation",
  noWrap: true,
  image:
    "https://icons.veryicon.com/png/o/miscellaneous/bim-management-platform/navigation-43.png",
  canHaveChildren: true,
  shouldReceiveBuilderProps: {
    builderBlock: true,
  },
  defaultChildren: [
    {
      "@type": "@builder.io/sdk:Element",
      component: {
        name: "Core:Button",
        options: {
          text: {
            "@type": "@builder.io/core:LocalizedValue",
            Default: "Request Quote",
          },
          dlt: "Sticky Navigation",
        },
      },
    },
  ],
  defaultStyles: {
    display: "block",
    position: "sticky",
    top: "0",
    zIndex: "11",
    backgroundColor: "var(--color-swdc-cool-gray-200)",
  },
  inputs: [
    {
      name: "links",
      type: "list",
      required: true,
      subFields: [
        {
          name: "title",
          type: "string",
          required: true,
          defaultValue: {
            "@type": "@builder.io/core:LocalizedValue",
            Default: "Link Title",
          },
          localized: true,
        },
        {
          name: "href",
          type: "string",
          required: true,
          localized: true,
          defaultValue: "#section",
          helperText: "Anchor link (e.g., #section-id)",
        },
        {
          ...DLT_FIELD,
          defaultValue: "Sticky Navigation",
        },
        DLD_FIELD,
      ],
      defaultValue: [
        {
          title: {
            "@type": "@builder.io/core:LocalizedValue",
            Default: "Section 1",
          },
          href: {
            "@type": "@builder.io/core:LocalizedValue",
            Default: "#section1",
          },
          dlt: "Sticky Navigation",
        },
        {
          title: {
            "@type": "@builder.io/core:LocalizedValue",
            Default: "Section 2",
          },
          href: {
            "@type": "@builder.io/core:LocalizedValue",
            Default: "#section2",
          },
          dlt: "Sticky Navigation",
        },
      ],
    },
  ],
};
